<template>
  <v-container class="custom-container custom-responsive-height">
    <v-row dense>
      <v-col cols="12">
        <v-card class="pa-5" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row dense>
            <v-col cols="12">
              <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search Manager ..." single-line solo
                hide-details class="custom-v-input" />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                  <v-data-table :headers="headers" :items="managers" :search="search" :items-per-page="5">
                    <template v-slot:item.sl="{ index }">
                      {{ index + 1 }}
                    </template>

                    <template v-slot:item.clients="{ item }">
                      <v-btn elevation="0" small
                        :class="isAssignedToManager(item.managerId, assignUser.manager) ? 'btn-assign red-remove' : 'btn-assign'"
                        @click="assignManager(assignUser.id, item.managerId)"
                        :loading="loadingManager === item.managerId">
                         {{ isAssignedToManager(item.managerId, assignUser.manager) ? 'Remove' : 'Assign' }}
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { REGISTERUSERDETAILS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  props: {
    assignUser: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "SL", value: "sl", align: "start" },
        { text: "Manager Name", value: "managerName" },
        { text: "Manager ID", value: "managerId" },
        { text: "Clients", value: "clients_count" },
        { text: "Action", value: "clients" },
      ],
      loadingManager: null,
    };
  },
  computed: {
    ...mapState("reguserdetails", ["managers"]),
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.GETMANAGERS, REGISTERUSERDETAILS__ACTIONS.ASSIGNUSER]),

    isAssignedToManager(managerId, managersString) {
      if (managerId == null || !managersString) return false;

      const managerList = managersString
        .toString()
        .split(',')
        .map(value => value.trim())
        .filter(value => value !== '');

      return managerList.includes(String(managerId));
    },

    async assignManager(userId, managerId) {
      try {
        this.loadingManager = managerId;

        const res = await this[REGISTERUSERDETAILS__ACTIONS.ASSIGNUSER]({
          userId,
          managerId,
        });

        const current = (this.assignUser.manager || '')
          .toString()
          .split(',')
          .map(v => v.trim())
          .filter(v => v !== '');

        const managerIdStr = String(managerId);

        let newList;
        if (current.includes(managerIdStr)) {
          newList = current.filter(id => id !== managerIdStr);
        } else {
          newList = [...current, managerIdStr];
        }
        this.assignUser.manager = newList.length ? newList.join(',') : null;
        await this[REGISTERUSERDETAILS__ACTIONS.GETMANAGERS]();
      } catch (error) {
        console.error("Error assigning user:", error);
      } finally {
        this.loadingManager = null;
      }
    }

  },

  created() {
    this[REGISTERUSERDETAILS__ACTIONS.GETMANAGERS]();
  },
};
</script>

<style scoped>
.red-remove {
  background-color: #FF567F !important;
  color: white !important;
  height: 36px !important;
  border-radius: 0;
  width: 100%;
  max-width: 86px;
}
</style>